import { BLOCKS } from '@contentful/rich-text-types'

export default {
  [BLOCKS.PARAGRAPH]: ({ content }, key, h, next) =>
    h('p', { key }, next(content, key, h, next)),
}
